import Box from './Box';

export default Box;
export type { IBoxProps } from './Box';
